import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import { CommonModule } from "@angular/common";

@Component({
    selector: "app-dash-news-dialog",
    imports: [SharedMaterialModule, SharedDsnModule, CommonModule],
    templateUrl: "./dash-news-dialog.component.html",
    styleUrl: "./dash-news-dialog.component.scss"
})
export class DashNewsDialogComponent implements OnInit {
    constructor(public dialogRef: MatDialogRef<DashNewsDialogComponent>) {}

    ngOnInit(): void {}
}
